var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "28px",
    viewBox: "12 16 32 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9977873,28.0869214 L28.6623686,19.4696119 C28.2565478,19.0950081 28.2312415,18.4623491 28.6058452,18.0565283 L29.2841253,17.3217249 C29.6587291,16.9159042 30.2913881,16.8905978 30.6972089,17.2652015 L43.360424,28.9543232 C43.7662447,29.3289269 43.7915511,29.961586 43.4169473,30.3674067 C43.3988671,30.3869936 43.3800109,30.4058498 43.360424,30.4239301 L30.6972089,42.1130517 C30.2913881,42.4876554 29.6587291,42.4623491 29.2841253,42.0565283 L28.6058452,41.3217249 C28.2312415,40.9159042 28.2565478,40.2832451 28.6623686,39.9086413 L38.2192318,31.0869214 L13,31.0869214 C12.4477153,31.0869214 12,30.6392062 12,30.0869214 L12,29.0869214 C12,28.5346367 12.4477153,28.0869214 13,28.0869214 L37.9977873,28.0869214 Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.403a69a1.svg";
export { ForwardRef as ReactComponent };